export default __webpack_public_path__ + "static/media/universal_payment_right.01d0a921.png";